/** @format */

import { ISchema } from '@formily/react'
import { FormLayout } from './FormLayout'
import { CSSStyle } from './CSSStyle'

export const Form: ISchema = {
  type: 'object',
  properties: {
    ...(FormLayout.properties as Record<string, unknown>),
    style: CSSStyle
  }
}
